export const enum EPermission {
    EDITOR = 'EDITOR',
    VIEWER = 'VIEWER',
}